register('cart', {
  onLoad() {
    //this._qtySelectors();
    
    window.addEventListener('initWishlistSlider', () => {
      this.wishlistItemSlider();
    });
  },
  _qtySelectors(){
    const $body = document.querySelector('body');
    // Qty selector has a minimum of 1 on the product page
    // and 0 in the cart (determined on qty click)
    let qtyMin = 1;
    const qtyadjuster = this.container.querySelectorAll('.js--qty-adjuster');
    qtyadjuster.forEach(adj => {
      adj.removeEventListener('click',(e)=>{});
    });  
    qtyadjuster.forEach(adj => {
      adj.addEventListener('click', (e)=> {
        e.preventDefault();
        let el = adj,
        //id = el.data('id'),
        qtySelector = el.parentNode.querySelector('.js--qty-num'),
        qty = parseInt(qtySelector.value.replace(/\D/g, ''));
        // Make sure we have a valid integer
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        if ( $body.classList.contains('template-cart') ) {
            qtyMin = 0;
        }
        // Add or subtract from the current quantity
        if (el.classList.contains('js--add')) {
            qty = qty + 1;
        } else {
            qty = qty - 1;
            if (qty <= qtyMin) qty = qtyMin;
        }
        // Update the input's number
        qtySelector.value = qty;
        triggerEvent(qtySelector, 'change');
      })
    });

    const qtyInputs = this.container.querySelectorAll('.js--qty-num');
    qtyInputs.forEach(qty => {
      qty.addEventListener('change', (e)=> {
        qty.closest('form.cart-form').submit();
      })
    });

    function triggerEvent(el, type) {
      // IE9+ and other modern browsers
      if ('createEvent' in document) {
          var e = document.createEvent('HTMLEvents');
          e.initEvent(type, false, true);
          el.dispatchEvent(e);
      } else {
          // IE8
          var e = document.createEventObject();
          e.eventType = type;
          el.fireEvent('on' + e.eventType, e);
      }
    }
  },
  wishlistItemSlider(){
    const initCollectionSlider = (sliders) => {
      sliders.forEach((el) => {
          const slider = tns({
              container: el,
              items: 2,
              gutter: 0,
              slideBy: 'page',
              center: false,
              autoplay: false,
              controls: true,
              nav: true,
              navPosition: 'bottom',
              mouseDrag: true,
              preventScrollOnTouch: 'auto',
              responsive: {
                  768: {
                      items: 4,
                  }
              }
          });     
      });
    }
    const wishlistSlider = document.querySelectorAll('.wishlist-items-slider');
    initCollectionSlider(wishlistSlider);
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});